import React from 'react'

import { GameWithUserInformation } from 'containers/GamesBlock/types'
import { useUser } from 'containers/MainLayout/selectors'
import useMutateFavorites from 'utils/hooks/queries/games/useMutateFavorites'

import { FavoriteIcon } from './styles'

interface Props {
  game: GameWithUserInformation
}

export function Favorite({ game }: Props) {
  const user = useUser()
  const { isFavorite, slug } = game
  const { mutate: mutateFavorite } = useMutateFavorites({ slug, isFavorite })

  if (!user.isLogged) {
    return null
  }

  const className = isFavorite ? `active-favorite active-favorite-${slug}` : ''

  return (
    <FavoriteIcon
      className={className}
      onClick={() => mutateFavorite()}
      active={isFavorite}
    />
  )
}
